import React from "react";
import moment from "moment";
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { RESOURCE } from "../../../const/resource";
import { useTranslation } from "react-i18next";

const MaintenancePartListExcelExport = (props: any) => {
  const { maintentenaceRecommendationParts, _maintenancePartExport } = props;
  const { t } = useTranslation();
    const exportData = maintentenaceRecommendationParts?.maintenanceRecommendedList?.map((item: any) => {
      item["serial"] = maintentenaceRecommendationParts?.serial;
      item["model"] = maintentenaceRecommendationParts?.model;
      item["unit"] = maintentenaceRecommendationParts?.unit;
      item["serviceIntervalHours"] = maintentenaceRecommendationParts?.serviceIntervalHours;
      return item;
  });
  return (
      <ExcelExport
      fileName={"MaintenancePartsLists" + moment().format("YYYYMMDDhhmmss") + ".xlsx"}
      data={exportData}
      ref={_maintenancePartExport}
    >
      <ExcelExportColumn
          key={0}
          title={t(RESOURCE.MyK_Grid_Part_Number)}
          field="partNo"
      />
      <ExcelExportColumn
          key={1}
          title={t(RESOURCE.MyK_Grid_Part_Description)}
          field="recommendationParts"
      />
      <ExcelExportColumn
        key={2}
        title={t(RESOURCE.MyK_Label_ManufacturerName)}
        field="manufacturer"
      />
      <ExcelExportColumn
        key={3}
        title={t(RESOURCE.MyK_Label_Model)}
        field="model"
      />
      <ExcelExportColumn
        key={4}
        title={`${t(RESOURCE.MyK_Label_Serial)}#`}
        field="serial"
      />
      <ExcelExportColumn
        key={5}
        title={`${t(RESOURCE.MyK_Label_Unit)}#`}
        field="unit"
      />
      <ExcelExportColumn
        key={6}
        title={t(RESOURCE.MyK_Grid_ServiceIntervalHours)}
        field="serviceIntervalHours"
      />
      <ExcelExportColumn
        key={7}
        title={t(RESOURCE.MyK_Grid_Quantity)}
        field="quantity"
      />
    </ExcelExport>
  );
};

export default MaintenancePartListExcelExport;
